import { useQuery } from "@apollo/client";

import { GqlPlannerV2VisitGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { ClientVisitListScreen_GetAllDocument } from "../screens/ClientVisitListScreen/queries.generated";

type UseClientVisitListScreen_GetAllParams = {
    clientId: string;
    params: GqlPlannerV2VisitGetAllParams;
};

export function useClientVisitListScreen_GetAll({ clientId, params }: UseClientVisitListScreen_GetAllParams) {
    const { data, loading, error } = useQuery(ClientVisitListScreen_GetAllDocument, {
        variables: {
            clientId: clientId,
            params: params,
        },
        fetchPolicy: "cache-and-network",
    });

    const queryInfo = data?.plannerV2VisitGetAll.queryInfo;
    const [_, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        total: total,
        sortableColumns: queryInfo?.sortableColumns,
        data: data?.plannerV2VisitGetAll.data,
    };
}
